export const OPERATIONS_GUIDED_TOUR_FOCUS_EVENT = 'operations-guided-tour-focus';
export const OPERATIONS_GUIDED_TOUR_TRAINING_EVENT = 'operations-guided-tour-training';

export interface OperationsGuidedTourFocusDetail {
  target: string | null;
}

export type OperationsGuidedTourTrainingEventType =
  | 'service_job_modal_opened'
  | 'service_job_created'
  | 'appointment_modal_opened'
  | 'appointment_tab_create_opened'
  | 'appointment_created'
  | 'job_costing_item_opened'
  | 'work_item_detail_opened'
  | 'work_item_tab_switched'
  | 'work_item_comment_added'
  | 'work_item_status_changed'
  | 'work_item_photo_uploaded'
  | 'work_item_signature_captured'
  | 'work_item_expense_added'
  | 'work_item_time_entry_added'
  | 'work_item_billing_updated'
  | 'work_item_breakdown_completed'
  | 'work_item_group_managed';

export type OperationsGuidedTourTrainingRoute =
  | 'service_job_modal'
  | 'appointment_modal'
  | 'appointment_assignees_modal'
  | 'appointments_tab'
  | 'job_costing_dashboard'
  | 'resource_schedule'
  | 'kanban_schedule'
  | 'work_item_detail'
  | 'work_item_overview'
  | 'work_item_breakdown'
  | 'work_item_billing'
  | 'work_item_photos'
  | 'work_item_signatures'
  | 'work_item_expenses'
  | 'work_item_time_tracking'
  | 'work_item_comments'
  | 'work_item_appointments'
  | 'work_item_team_performance'
  | 'work_item_capacity_budget'
  | 'work_item_groups';

export interface OperationsGuidedTourTrainingEventDetail {
  type: OperationsGuidedTourTrainingEventType;
  occurredAt: string;
  route?: OperationsGuidedTourTrainingRoute | null;
  workItemId?: string | null;
  itemType?: string | null;
  metadata?: Record<string, unknown> | null;
}

export function emitOperationsGuidedTourTrainingEvent(
  detail: Omit<OperationsGuidedTourTrainingEventDetail, 'occurredAt'> & Partial<Pick<OperationsGuidedTourTrainingEventDetail, 'occurredAt'>>,
): void {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(new CustomEvent<OperationsGuidedTourTrainingEventDetail>(OPERATIONS_GUIDED_TOUR_TRAINING_EVENT, {
    detail: {
      ...detail,
      occurredAt: detail.occurredAt || new Date().toISOString(),
    },
  }));
}
